import axios_instance from '../utilities/axios_instance';
import { validateMetadata } from '../components/crop-intelligence/contract';

const CCDatasetService = {
  async getDatasets(country, signal) {
    const response = await axios_instance.get('ccdatasets', {
      params: { country_code: country }, signal, timeout: 15000,
    });
    return validateMetadata(response.data.data);
  },
};

export default CCDatasetService;
